export const messages = {
  title: 'عنوان',
  optionalRoles: 'گروه هدف اختیاری',
  mandatoryRoles: 'گروه هدف الزامی',
  action: 'ویرایش',
  addTopic: 'افزودن سرفصل آموزشی',
  nameCantBeEmpty: 'عنوان نمی‌تواند خالی باشد',
  status: 'وضعیت',
  Exists: 'تایید شده',
  Archived: 'حذف شده',
  Proposed: 'پیشنهادی',
  Disabled: 'غیرفعال',
  State_Exists: 'تایید',
  State_Archived: 'حذف',
  State_Disabled: 'غیرفعال',
  State_Proposed: 'پیشنهادی',
  Active: 'فعال',
  emptyNotic:
    'با خالی گذلشتن هر فیلد، آن فیلد در هنگام انتخاب توسط فرد تکمیل می‌شود و گزارش آن در اختیار شما قرار می‌گیرد',
  topicList: 'لیست سرفصل‌های آموزشی',
  editClassTemplate: 'ویرایش الگوی دوره',
  createClassTemplate: 'ساخت الگوی دوره',
  save: 'ذخیره',
  batchAdd: 'افزودن تجمیعی',
  topicNamesPlaceHolder: 'عناوین سرفصل‌ها',
  questionBank: 'بانک سوالات',
  cancel: 'لغو',
  noOne: 'هیچ گروهی انتخاب نشده',
  search: 'جستجو',
  suggestedTopic: 'پیشنهاد پرسنل',
  onlyOptional: 'فقط اختیاری',
  onlyMandatory: 'فقط الزامی',
  searchTargetGroup: 'جستجوی گروه هدف',
  duplicatedName: 'عنوان انتخاب شده تکراری است.',

  editingTemplateClassFor(topicName: string) {
    return `ویرایش قالب دوره آموزشی برای سرفصل «${topicName}»`;
  },
};
